import { motion } from "framer-motion";
import { useState, useEffect, useRef } from "react";

const AnimatedScroll = ({ children, duration = 0.8, offset = 50 }) => {
  const [hasAppeared, setHasAppeared] = useState(false); // bloque la disparition
  const ref = useRef(null);

  useEffect(() => {
    const node = ref.current; // capture locale du ref pour le cleanup
    if (!node) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setHasAppeared(true); // déclenche l'animation une seule fois
          observer.unobserve(node);
        }
      },
      {
        root: null,
        rootMargin: `0px 0px -${offset}px 0px`,
        threshold: 0.2,
      }
    );

    observer.observe(node);

    return () => {
      // utilise la même référence capturée
      if (node) observer.unobserve(node);
      observer.disconnect();
    };
  }, [offset]);

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 30 }}
      animate={hasAppeared ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
      transition={{ duration, ease: "easeOut" }}
    >
      {children}
    </motion.div>
  );
};

export default AnimatedScroll;
